// extracted by mini-css-extract-plugin
export default {"warningIconWrapper":"NotUsingRolePermissionsWarningComponent_warningIconWrapper__F5pPh","warningWrapper":"NotUsingRolePermissionsWarningComponent_warningWrapper__p1MHV"};